<section class="cmn-innerpage-wrapper" *ngIf="staticPageData">
  <div class="inner-content dashboard">
    <div class="head">
      <h1>Info Pages</h1>
    </div>
    <div class="static-page">
      <div class="page-key" [innerHTML]="staticPageData.key"></div>
      <div
        class="translations"
        *ngFor="let translation of staticPageData.translations"
      >
        <div class="translation-card">
          <h3 class="lang-title">
            Language : {{ getLanguageName(translation.langId) }}
          </h3>
          <div
            class="translation-content"
            [innerHTML]="translation.content"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
